import {
  TEXT,
  BUTTON, SHAPE, RECTANGLE, LINE, IMAGE, CONTAINER,
  MENU, SEEK, CONTENT, FORM, EXTERNAL_FORM, IFRAME, HTML, CHARTS, VIDEO,
  ASSET, AI_IMAGE_WIDGET, PROMPT_WIDGET, LIVE_ELEMENT,
  GROUP, CAROUSEL, ANCHOR,
} from 'constants/widgetTypes';

const FLEX_FLOW_BY_TYPE = {
  [TEXT]: { preserveWidth: true },
  [BUTTON]: { preserveSize: true },
  [SHAPE]: { preserveSize: true },
  [RECTANGLE]: { preserveSize: true },
  [LINE]: { preserveSize: true },
  [IMAGE]: { preserveSize: true },
  [CONTAINER]: { preserveWidth: true },
  // Fixed-box widgets that don't come under flex mode — keep their W/H in flow.
  [MENU]: { preserveSize: true },
  [SEEK]: { preserveSize: true },
  [CONTENT]: { preserveSize: true },
  [FORM]: { preserveSize: true },
  [EXTERNAL_FORM]: { preserveSize: true },
  [IFRAME]: { preserveSize: true },
  [HTML]: { preserveSize: true },
  [CHARTS]: { preserveSize: true },
  [VIDEO]: { preserveSize: true },
  [ASSET]: { preserveSize: true },
  [AI_IMAGE_WIDGET]: { preserveSize: true },
  [PROMPT_WIDGET]: { preserveSize: true },
  [LIVE_ELEMENT]: { preserveSize: true },
  [GROUP]: { preserveSize: true },
  [ANCHOR]: { escapesFlexFlow: true },
};

export function flexFlowForType(typeOrWidget) {
  if (!typeOrWidget) return {};
  const type = typeof typeOrWidget === 'string' ? typeOrWidget : typeOrWidget.type;

  if (type === CAROUSEL && typeof typeOrWidget !== 'string') {
    const free = typeOrWidget?.properties?.desktop?.free === true;
    if (free) return { preserveWidth: true };
  }

  return FLEX_FLOW_BY_TYPE[type] || {};
}

// Widgets flagged escapesFlexFlow stay at their own transform instead of
// flowing as flex items when the parent is in flex mode.
export function breaksOutOfFlexFlow(typeOrWidget) {
  return flexFlowForType(typeOrWidget).escapesFlexFlow === true;
}
